'use strict';

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
   value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
   return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
   return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.create = create;
exports.visitExpressions = visitExpressions;

var _utils = require('./utils');

function _toConsumableArray(arr) {
   if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
         arr2[i] = arr[i];
      }return arr2;
   } else {
      return Array.from(arr);
   }
}

function topic(id) {
   for (var _len = arguments.length, subtopics = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      subtopics[_key - 1] = arguments[_key];
   }

   return [].concat(_toConsumableArray(id.replace(/[_/]./g, function (_) {
      return _.charAt(1).toUpperCase();
   }).split('-')), subtopics).join('+');
}

var EXPRESSION_PATTERN = /\$\{([^}]+)\}/g;

var DEFAULT_MATCHERS = [{
   pattern: /^topic:(.*)$/,
   callback: function callback(context, _) {
      for (var _len2 = arguments.length, subtopics = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
         subtopics[_key2 - 2] = arguments[_key2];
      }

      return topic.apply(undefined, [context.id].concat(subtopics));
   }
}, {
   pattern: /^features\..*$/,
   callback: function callback(context, expression) {
      return (0, _utils.path)(context, expression);
   }
}];

function create() {
   var matchers = [].concat(DEFAULT_MATCHERS);

   return {
      addPattern: function addPattern(pattern, callback) {
         matchers.push({
            pattern: pattern,
            callback: callback
         });
         return this;
      },
      interpolate: function interpolate(context, object) {
         return visitExpressions(object, function (expression) {
            for (var i = 0; i < matchers.length; i++) {
               var _matchers$i = matchers[i],
                   pattern = _matchers$i.pattern,
                   callback = _matchers$i.callback;

               var match = pattern.exec(expression);

               if (match) {
                  return callback.apply(undefined, [context].concat(_toConsumableArray(match)));
               }
            }

            throw new Error('"${' + expression + '}" cannot be expanded here');
         });
      }
   };
}

function visitExpressions(obj, f) {
   if (obj === null) {
      return obj;
   }

   if (typeof obj === 'string') {
      var match = EXPRESSION_PATTERN.exec(obj);
      EXPRESSION_PATTERN.lastIndex = 0;

      if (match && match.index === 0 && match[0] === obj) {
         // exact matches may return non-strings
         return f(match[1]);
      }

      return obj.replace(EXPRESSION_PATTERN, function (_, expression) {
         return f(expression);
      });
   }

   if (Array.isArray(obj)) {
      return obj.map(function (value) {
         return visitExpressions(value, f);
      }).filter(function (_) {
         return _ !== undefined;
      });
   }

   if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
      var result = {};
      Object.keys(obj).forEach(function (key) {
         var value = obj[key];

         var replacedKey = visitExpressions(key, f);
         var replacedValue = visitExpressions(value, f);

         if (typeof replacedValue !== 'undefined' && typeof replacedKey !== 'undefined') {
            result[replacedKey] = replacedValue;
         }
      });
      return result;
   }

   return obj;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/laxar-tooling/lib/expression_interpolator.js
// module id = 11
// module chunks = 0